module.exports = [{
      plugin: require('../node_modules/@qite/gatsby-source-tide/gatsby-browser.js'),
      options: {"plugins":[],"host":"https://tide-voetbalreizen7952.tidesoftware.be","apiKey":"IbHvQxUw6yJONvk3F5U6ZIKeuxmuvnbryZtYCSrhqPj148KT8vzNVXhM2QOjBQGh","channelId":3,"isPreview":false,"ignoreSslErrors":true,"useImageFiles":false},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Sportreizen","short_name":"Sportreizen","start_url":"/","background_color":"#EF8121","theme_color":"#EF8121","display":"minimal-ui","icon":"src/images/sportreizen/sportreizen-icon.png","crossOrigin":"use-credentials","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","include_favicon":true,"cacheDigest":"4aa0e99cdf56529e07be88ae27b12cee"},
    },{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.sportreizen.com","stripQueryString":true},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
